// extracted by mini-css-extract-plugin
export default {"backgroundSection":"BackgroundSection_backgroundSection__YQd4n","container":"BackgroundSection_container__Q1qB0","titleHome":"BackgroundSection_titleHome__VDqTS"};